import update from 'immutability-helper';
import {
   INITIAL_SYNC_RESPONSE,
   LOAD_SELECTED_LOOP_KITS,
   SET_ASSETS_PERMISSIONS_FROM_SESSION_STORAGE,
   SET_SELECTED_LOOP_KITS,
   SET_USER_DATA,
} from './actions';
import { authStatuses, permissionsStatuses } from '../util/constants';
import { defaultSelectedLoopKits } from './defaultSelectedLoopKits';

const appReducer = (
   state = {
      userData: { status: authStatuses.pending },
      permissions: { status: permissionsStatuses.pending },
      selectedLoopKits: defaultSelectedLoopKits,
   },
   action
) => {
   switch (action.type) {
      case SET_USER_DATA: {
         let nextPermissionsStatus = state.permissions.status;
         if (action.userData.status === authStatuses.unauthenticated) {
            nextPermissionsStatus = permissionsStatuses.loaded;
         } else if (nextPermissionsStatus !== permissionsStatuses.pending) {
            nextPermissionsStatus = permissionsStatuses.loading;
         }

         // handle log out... if handling in this way causes issues, can create actual log out action instead of reling on loading -> unauthenticated
         if (
            state.userData.status === authStatuses.loading &&
            action.userData.status === authStatuses.unauthenticated
         ) {
            return update(state, {
               userData: { $set: action.userData },
               permissions: {
                  $set: {
                     status: nextPermissionsStatus,
                  },
               },
            });
         }

         return update(state, {
            userData: { $set: action.userData },
            permissions: {
               status: { $set: nextPermissionsStatus },
            },
         });
      }

      case INITIAL_SYNC_RESPONSE:
         return { ...state, showSignUp: false };

      case SET_ASSETS_PERMISSIONS_FROM_SESSION_STORAGE: {
         const { token, expiration, errorCode } = JSON.parse(
            sessionStorage.getItem('eiauth-accessTokenResponse')
         );
         return {
            ...state,

            permissions: {
               status:
                  errorCode == null
                     ? permissionsStatuses.loaded
                     : permissionsStatuses.failed,
               token,
               expiration,
               errorCode,
            },
         };
      }

      case LOAD_SELECTED_LOOP_KITS: {
         return {
            ...state,
            selectedLoopKits: { loading: true },
         };
      }

      case SET_SELECTED_LOOP_KITS: {
         return {
            ...state,
            selectedLoopKits: action.selectedLoopKits,
         };
      }

      default:
         return state;
   }
};

export { appReducer };
